import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';
import { Activity } from '@warema/shared/company-search/models';
import { AppointmentRequestActivityType } from '@warema/shared/models';
import * as ActivityActions from './activity.actions';

export const activityAdapter: EntityAdapter<Activity> = createEntityAdapter<Activity>();

export interface ActivityState extends EntityState<Activity> {
    selectedActivity: AppointmentRequestActivityType;
}

const initialState: ActivityState = activityAdapter.addMany(
    [
        {
            id: 1,
            type: AppointmentRequestActivityType.ConsultationAtShowroom,
            label: 'showroom',
        },
        {
            id: 2,
            type: AppointmentRequestActivityType.ConsultationAtHome,
            label: 'home',
        },
        {
            id: 3,
            type: AppointmentRequestActivityType.RepairOrService,
            label: 'service',
        },
        {
            id: 4,
            type: AppointmentRequestActivityType.DamageReport,
            label: 'damage-report',
        },
    ],
    activityAdapter.getInitialState({
        selectedActivity: AppointmentRequestActivityType.Unknown,
    }),
);

export const activityReducer = createReducer(
    initialState,
    on(ActivityActions.ActivitySelected, (state, { activityType }): ActivityState => {
        return { ...state, selectedActivity: activityType };
    }),

    on(ActivityActions.resetSelectedActivity, (state): ActivityState => {
        return { ...state, selectedActivity: AppointmentRequestActivityType.Unknown };
    }),
);

export function reducer(state: ActivityState | undefined, action: Action): ActivityState {
    return activityReducer(state, action);
}
